module.exports = __webpack_public_path__ + "img/eye.0b2869a0.svg";